import { Button, Stack, TableCell, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useChecklistQa } from "./ChecklistQaContext";

export default function ChecklistQaNoteCell({ taskId }: { taskId: number }) {
  const qa = useChecklistQa();
  const note = qa.state.notes.find((n) => n.taskId === taskId);
  const [draft, setLocalDraft] = useState<string | undefined>(() => qa.drafts[taskId]);
  useEffect(() => {
    setLocalDraft(qa.drafts[taskId]);
  }, [taskId, qa.state, qa.saving, qa.loading]);
  const value = draft ?? note?.text ?? "";
  const dirty = value.trim() !== (note?.text || "");
  if (!qa.access.canViewOrder || (!qa.access.isEligible && !qa.state.notes.length)) return null;
  return <TableCell sx={{ verticalAlign: "top", minWidth: 220 }}>
    <Stack spacing={0.5}>
      {qa.access.canEditNotes ? <TextField
        value={value} onChange={(e) => {
          setLocalDraft(e.target.value);
          qa.setDraft(taskId, e.target.value);
        }}
        placeholder="QA Note" size="small" multiline fullWidth minRows={2} maxRows={8}
        disabled={qa.saving || qa.loading || qa.error}
        inputProps={{ className: "checklist-qa-note", maxLength: 4000, "aria-label": `QA note for task ${taskId}` }}
      /> : <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{note?.text || "—"}</Typography>}
      {dirty && <Stack direction="row" spacing={1}>
        <Button size="small" disabled={qa.saving || qa.loading || qa.error} onClick={() => qa.saveNote(taskId)}>Save QA note</Button>
        <Button size="small" disabled={qa.saving} onClick={() => {
          setLocalDraft(undefined);
          qa.setDraft(taskId, undefined);
        }}>Cancel</Button>
      </Stack>}
      {note && <Typography variant="caption" color="text.secondary">{note.updatedBy} · {new Date(note.updatedAt).toLocaleString()}</Typography>}
    </Stack>
  </TableCell>;
}
